// src/components/LoadingAnimation.jsx

import React from 'react';
import Lottie from 'lottie-react';
import animationData from '../assets/loadingAnimation.json'; // Asegúrate de que el nombre del archivo coincida
import { Center, VStack, Text } from '@chakra-ui/react';

export default function LoadingAnimation() {
  return (
    <Center h="100vh" w="100vw" bg="white">
      <VStack>
        <Lottie 
          animationData={animationData}
          loop={true} // La animación se repetirá mientras carga
          style={{ width: 250, height: 250 }} // Ajusta el tamaño según tu animación
        />
        <Text fontWeight="bold" color="gray.600">¡¡Ace!!</Text>
      </VStack>
    </Center>
  );
}